import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { getActivity } from '@/api/NeighborAppointmentApi'
import OfficialActivitie from '@/views/mulin/components/OfficialActivitie.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Finish',
  setup(__props) {

async function search({ index, setData }) {
    const pagesize = 6;
    var datainfo = await getActivity({ pageNum: index, pagesize, activityStatus: 3 });
    setData(datainfo.rows, datainfo.total);
}

return (_ctx: any,_cache: any) => {
  const _component_app_list = _resolveComponent("app-list")!

  return (_openBlock(), _createBlock(_component_app_list, { onLoadData: search }, {
    default: _withCtx((slotProps) => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.list, (item, index) => {
        return (_openBlock(), _createBlock(OfficialActivitie, {
          key: item.id,
          itemData: item,
          "not-border": index == slotProps.list.length - 1
        }, null, 8, ["itemData", "not-border"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})